// @flow
import Experiment from '@homeaway/react-experiment';
import {SVGIcon} from '@homeaway/react-svg';
import {TOUR_360__24} from '@homeaway/svg-defs';
import debounce from 'lodash.debounce';
import React from 'react';

import {HA_SERP_VIRTUAL_TOUR_BADGE} from '../../abacus/experiments';
import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import './VirtualTourBadge.less';

import type {BadgeShape} from '../Hit/Hit';

const handleMouseEnter = debounce(() => {
    trigger(GENERIC_EVENT, {
        eventaction: 'hover virtual tour badge'
    });
}, 100);

export type Props = {
    badge: BadgeShape
};

export function VirtualTourBadge(props: Props) {
    return (
        <Experiment name={HA_SERP_VIRTUAL_TOUR_BADGE}>
            {({On}) => (
                <On>
                    <div
                        className="VirtualTourBadge"
                        onMouseEnter={handleMouseEnter}
                        role="presentation"
                    >
                        <div className="VirtualTourBadge__icon">
                            <SVGIcon markup={TOUR_360__24} aria-hidden />
                        </div>
                        <div className="VirtualTourBadge__text-container">
                            <span className="VirtualTourBadge__text">
                                {props.badge.name}
                            </span>
                        </div>
                    </div>
                </On>
            )}
        </Experiment>
    );
}
